import { Controller } from "@hotwired/stimulus"

// Navigates to a URL on click
// Usage: <div data-controller="navigate" data-navigate-url-value="/path" data-action="click->navigate#go">
export default class extends Controller {
  static values = {
    url: String
  }

  go() {
    if (this.hasUrlValue) {
      window.location = this.urlValue
    }
  }
}
